export default "__VITE_ASSET__DRzZwdWT__"